export default "__VITE_ASSET__DncAG_a8__"